<template>
	<div
		:class="[
			'custom_select select_area',
			{ active: openOptions },
			{ disable: disable },
		]"
		ref="selectDiv"
		@blur="focusHandler"
		@click="toggleOptions"
		tabindex="-1"
	>
		<div v-if="!selectedItem" class="label">
			{{ placeholder }}
		</div>
		<div v-else class="item_wrap">
			<div class="selected_item asset_box">
				<span :class="[selectedAsset.code, 'small']"></span>
				<p class="code mr_4">{{ selectedAsset.code }}</p>
				<p class="name">{{ selectedAsset.title }}</p>
			</div>
			<div v-if="showAccount && selectedAccount">
				<!--				<span class="divide_line"></span>-->
				<div class="num_unit">
					<p class="num">{{ selectedAccount.balance }}</p>
					<p class="unit">{{ selectedAccount.asset_code }}</p>
				</div>
			</div>
		</div>
		<transition name="slide-fade">
			<ul class="optionList" v-if="openOptions">
				<li v-if="searchable" class="search_item">
					<input
						ref="search"
						name="search"
						type="text"
						v-model="searchKeyword"
						@blur="focusHandler"
					/>
				</li>
				<li v-if="searchable && optionList.length === 0" class="empty_item">
					검색 결과 없음
				</li>
				<li
					v-for="item in optionList"
					class="optionItem asset_box"
					@click.stop="selectItem(item.seq)"
					:key="item.seq"
				>
					<span :class="[item.code, 'small']"></span>
					<p class="code mr_4">{{ item.code }}</p>
					<p class="name">{{ item.title }}</p>
				</li>
			</ul>
		</transition>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { filter } from 'lodash';

export default {
	name: 'CustomSelectBox',
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		disable: {
			type: Boolean,
			default: false,
		},
		showAccount: {
			type: Boolean,
			default: false,
		},
		searchable: {
			type: Boolean,
			default: false,
		},
		options: {
			type: Array,
		},
	},
	data() {
		return {
			openOptions: false,
			searchKeyword: '',
			selectedItem: null,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('assets', ['assets']),
		selectedAsset() {
			return this.options.find(item => {
				return item.seq === this.selectedItem;
			});
		},
		selectedAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedItem;
			});
		},
		optionList() {
			return filter(this.options, item => {
				return (
					item.code.toLowerCase().includes(this.searchKeyword.toLowerCase()) ||
					item.title.toLowerCase().includes(this.searchKeyword.toLowerCase())
				);
			});
		},
	},
	methods: {
		toggleOptions() {
			if (this.options.length === 0) return;
			if (document.activeElement.type === 'text') return;
			this.openOptions = !this.openOptions;
		},
		focusHandler(e) {
			if (this.$refs.selectDiv === e.relatedTarget) return;
			if (e.relatedTarget?.name === 'search') return;
			this.openOptions = false;
		},
		selectItem(seq) {
			this.selectedItem = seq;
			this.openOptions = false;
			this.$emit('selectItem', seq);
		},
		initSelected() {
			this.selectedItem = null;
		},
	},
	updated() {
		if (this.searchable && this.openOptions) {
			this.searchKeyword = '';
			this.$refs.search.focus();
		}
	},
};
</script>

<style scoped></style>
